"use client";

import Link from "next/link";
import { JamInstagram } from "@/assets/icons/jam-instagram";
import { FlowbiteGoogle } from "@/assets/icons/flowbite-google";
import backgroundlines from "@/assets/images/footer/backgrounds-lines.webp";

export const Footer = () => {
  const navLinks = [
    { name: "Accueil", href: "/" },
    { name: "Le lieu", href: "/#place" },
    { name: "Le concept", href: "/#concept" },
    { name: "Les équipements", href: "/#equipments" },
    { name: "Nos offres", href: "/#offers" },
    { name: "Nous contacter", href: "/#contact" },
  ];

  const localSeoLinks = [
    { name: "Coworking Paris 9", href: "/coworking-paris-9" },
    { name: "Coworking Gare du Nord", href: "/coworking-gare-du-nord" },
    { name: "Coworking Paris Nord", href: "/coworking-paris-nord" },
    { name: "Bureaux privés Paris 9", href: "/bureaux-prives-paris-9" },
    { name: "Open space Paris 9", href: "/open-space-paris-9" },
    { name: "Salles de réunion Paris 9", href: "/salles-reunion-paris-9" },
  ];

  return (
    <footer
      className="relative overflow-hidden rounded-t-3xl bg-[#fde8e8] px-4 pb-8 pt-14 text-black sm:px-6 lg:px-10"
      style={{
        backgroundImage: `url(${backgroundlines.src})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom center",
        backgroundSize: "cover",
      }}
    >
      <div className="relative mx-auto w-full max-w-[1500px]">
        <div className="grid grid-cols-1 gap-12 pb-10 md:grid-cols-2 xl:grid-cols-[minmax(220px,1fr)_minmax(200px,1fr)_minmax(220px,1fr)_minmax(230px,1fr)]">
          <div className="min-w-0">
            <Link
              href="/"
              className="flex items-center gap-2 text-3xl font-bold"
            >
              <span className="text-black">Espace</span>
              <span className="text-primary">Cadet</span>
            </Link>
            <div className="mt-4 flex gap-4">
              <Link
                href="https://www.instagram.com/espacecadet/"
                target="_blank"
                className="hover:opacity-75"
              >
                <JamInstagram className="h-8 w-8 text-black" />
              </Link>
              <Link
                href="https://maps.app.goo.gl/YKpMrog1qbStxxn36"
                target="_blank"
                className="hover:opacity-75"
              >
                <FlowbiteGoogle className="h-8 w-8 text-black" />
              </Link>
            </div>
          </div>

          <div className="min-w-0 space-y-4">
            <h3 className="text-2xl font-semibold leading-tight">Navigation</h3>
            <nav className="flex flex-col gap-3 text-lg text-[#333]">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="w-fit hover:text-primary"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          <div className="min-w-0 space-y-4 text-lg">
            <h3 className="text-2xl font-semibold leading-tight">
              Pages locales
            </h3>
            <nav className="flex flex-col gap-2 text-base text-[#333]">
              {localSeoLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="w-fit hover:text-primary"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          <div className="min-w-0 space-y-4 text-lg">
            <h3 className="text-2xl font-semibold leading-tight">
              Localisation
            </h3>
            <div className="flex flex-col gap-2 text-[#222]">
              <p>Espace Cadet</p>
              <p>5 rue Marguerite de Rochechouart</p>
              <p>75009 Paris</p>
              <Link
                href="tel:+33610788013"
                className="w-fit hover:text-primary"
              >
                06 10 78 80 13
              </Link>
              <Link
                href="mailto:compta@espacecadet.com"
                className="w-fit break-all text-base hover:text-primary"
              >
                compta@espacecadet.com
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-black/10 pt-5 text-sm text-gray-600 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-col gap-1 text-left sm:flex-row sm:gap-4">
            <p>© {new Date().getFullYear()} Espace Cadet</p>
            <p>
              Réalisé par{" "}
              <Link
                href="https://www.next-generation.dev/"
                className="hover:text-primary"
                target="_blank"
                rel="noopener"
                title="Next Generation"
              >
                Next Generation
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link href="/mentions-legales" className="hover:text-primary">
              Mentions légales
            </Link>
            <Link
              href="/politique-confidentialite"
              className="hover:text-primary"
            >
              Politique de confidentialité
            </Link>
            <Link href="/cookies" className="hover:text-primary">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
